module.exports = "<div class=\"col-md-12 input-group\"> <input id=search-box type=text placeholder=Buscar... class=\"form-control no-brd\" ng-class=vm.barClasses ng-model=vm.filter ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.onChange({search: vm.filter})\"/> <span class=\"input-group-addon squarerify no-brd\" ng-class=vm.barClasses> <i ng-class=vm.iconClasses ng-show=vm.searchIcon></i> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/components/search-bar.html
// module id = 442
// module chunks = 0